import Image from 'next/image';
import { useEffect, useState } from 'react';
import Collapsible from 'react-collapsible';
import { images } from '../../../Constants/ImageUrls';
import {
  applyGesture,
  handleWidgetAccToUser,
} from '../../../Utils/productPageUtils';
import Grid from './Grid';
import { categoryNameCollapsed, categoryNameExpanded } from './common';
import { SectionContainer, SectionTitle } from './styled';

export default function AboutGrid(props) {
  const {
    itemData,
    clickedHandler,
    productCategory,
    index,
    Ido,
    WidgetContainImage,
    clinic,
    openWidgetOnClick,
    showNewLandingPageUI,
  } = props;
  const widgetIsOpened = Ido || !itemData.default_collapsed;
  const [openWidget, setOpenWidget] = useState(widgetIsOpened);
  const [plusMinusDropDown, setPlusMinusDropDown] = useState(
    openWidget ? images.minusSvg : images.plusBlack,
  );
  const [gestureEffect, setGestureEffect] = useState('');
  const [widgetHandle, setWidgetHandle] = useState({
    widgetImage: '',
    widgetClass: '',
  });
  const handleWidgetState = (categoryNameState, widgetOpen, imageType) => {
    applyGesture(setGestureEffect);
    clickedHandler(categoryNameState, index, itemData.title);
    setPlusMinusDropDown(imageType);
  };
  // useEffect(() => {
  //     setOpenWidget(showCollapsedView(index, WidgetContainImage));
  // }, [itemData]);

  useEffect(() => {
    handleWidgetAccToUser(plusMinusDropDown, setWidgetHandle);
  }, [plusMinusDropDown]);
  useEffect(() => {
    const state = widgetIsOpened;
    setOpenWidget(state);
  }, [itemData.default_collapsed]);

  useEffect(() => {
    if (openWidgetOnClick === itemData.title.toLowerCase() && !openWidget) {
      setOpenWidget(true);
    }
  }, [openWidgetOnClick]);
  useEffect(() => {
    if (openWidget)
      handleWidgetState(categoryNameExpanded, true, images.minusSvg);
    else handleWidgetState(categoryNameCollapsed, false, images.plusBlack);
  }, [openWidget]);
  return (
    <SectionContainer
      showNewLandingPageUI={showNewLandingPageUI}
      productcategory={productCategory}
    >
      <a id={itemData.title.toLowerCase()} rel="nofollow"></a>
      <Collapsible
        trigger={
          <SectionTitle className={` ${gestureEffect} aplusTitleSize`}>
            {itemData.title}
            {widgetHandle.widgetImage ? (
              <Image
                src={widgetHandle.widgetImage}
                className={widgetHandle.widgetClass}
                alt="arrow"
                loading="lazy"
                height={24}
                width={24}
              />
            ) : null}
          </SectionTitle>
        }
        key={index}
        onOpening={() => {
          setOpenWidget(true);
        }}
        onClosing={() => {
          setOpenWidget(false);
        }}
        transitionTime={200}
        open={openWidget}
        triggerOpenedClassName="triggerClassAplus"
      >
        <Grid itemData={itemData} />
      </Collapsible>
    </SectionContainer>
  );
}
